export const api_key = "CNCPp6ZHsQYIjaZ4fFTs";
export const sdkWrapperURL = (url = "") => new URL("/v2" + url, "https://api-staging-sdk-wrapper-app.carenow.healthcare");
export const sdkURL = (url = "") => new URL(url, "https://sdk-staging.carenow.healthcare");
